export default "https://c.travel-assets.com/partner-portal/reservations.c9eae0434fe7.svg";